import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BomNoteDto } from './bom-note.dto';

@Injectable({ providedIn: 'root' })
export class BomNotesProvider {
  constructor(private http: HttpClient) {}

  getNotes(bomItemId: number): Observable<BomNoteDto[]> {
    const url = `/api/bom/${bomItemId}/notes`;
    return this.http.get<BomNoteDto[]>(url);
  }

  createNote(bomItemId: number, content: string): Observable<BomNoteDto> {
    const url = `/api/bom/${bomItemId}/notes`;
    return this.http.post<BomNoteDto>(url, { content });
  }
}
